var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{'text-error' : !_vm.value && _vm.highlightIfMissing}},[(!_vm.value)?[_vm._v(" Not supplied ")]:[_vm._v(" "+_vm._s(_vm.value)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }